import React from "react";

// Components //
import {
  PageHeading,
  TableRowLoader,
} from "../../common/components/index";
import Table from "react-bootstrap/Table";

import { useSelector } from "react-redux";

import { downloadCsv } from "../../api/downnloadCsv";

const DownloadCSVFiles = () => {
  // Hooks //
  const { loading } = useSelector((state) => state.utils);
  const { userToken } = useSelector((state) => state.user)

  const csvFolders = [
    {
      csvFileRef: '001',
      csvFileName: 'Sites \ Projects',
      downloadLink: 'sites'
    },
    {
      csvFileRef: '002',
      csvFileName: 'Sub-Contractors',
      downloadLink: 'sub-contractor'
    },
    {
      csvFileRef: '003',
      csvFileName: 'Induction Docs',
      downloadLink: 'induction-docs'
    },
    {
      csvFileRef: '004',
      csvFileName: 'training Matrix',
      downloadLink: 'training-matrix'
    },
    {
      csvFileRef: '005',
      csvFileName: 'Assets Allocation',
      downloadLink: 'assets-allocation'
    }
  ]

  const downoadCsvs = async (type) => {
    if (type) {
      const data = await downloadCsv(userToken, type)
      const fileurl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = fileurl;
      link.setAttribute('download', `${type}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  }

  return (
    <div id="induction">
      <PageHeading title={"Download CSV Files"} />
      <div className="right-sec_cont">
        {loading ? (
          <TableRowLoader limit={8} />
        ) : (
          <>
            <Table className="common-table documents_table " bordered>
              <thead>
                <tr>
                  <th role="button">
                    CSV File Reference
                  </th>

                  <th>CSV File Name</th>

                  <th>Site Specific Training Matrix</th>
                </tr>
              </thead>
              <tbody>
                {csvFolders?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {item.csvFileRef}
                    </td>
                    <td>
                      {item.csvFileName}
                    </td>
                    <td>
                      {item.csvFileName === 'Assets Allocation' ? <p>Coming Soon</p> : <button onClick={() => downoadCsvs(item.downloadLink)}>Download</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </div>
    </div>
  );
};

export default DownloadCSVFiles;
